export default __webpack_public_path__ + "static/SamsungSharpSansMedium-5d992ee0ac0fb8516f0f2d78d4cc0f39.woff";